import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { Observable, from, of, switchMap } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { getFormatsFromFormatParam } from './get-formats-from-format-param';

export const convertStoryblokRelationshipsResolver: ResolveFn<Observable<ISbStoryData[]>> = route => {
  const storyblokService = inject(PICFLOW_STORYBLOK);

  const { to: toFormatSlug } = getFormatsFromFormatParam(route.params.format);
  const path = toFormatSlug ? 'convert/conversion-template' : 'convert/format-template';

  return storyblokService.getStory(path, route).pipe(
    switchMap(story => {
      if (!story) return of(null);
      return from(storyblokService.resolveRelationshipsFromStory(story.story, route));
    })
  );
};
